import React from "react";

const DropdownSpecialisationListing = ({
	labelFor,
	options,
	disabled,
	setSelectedSpecialisation,
	selectedHospital,
	defaultValue,
}) => {
	return (
		<div style={{ position: "relative" }}>
			<div style={{ position: "relative", zIndex: "2" }}>
				<select
					className="form-select form-select-lg"
					aria-label=".form-select-lg"
					id={labelFor}
					value={defaultValue}
					onChange={(e) => setSelectedSpecialisation(e.target.value)}
					style={{
						appearance: "none",
						fontWeight: selectedHospital ? "700" : "300",
						color: selectedHospital ? "black" : "#A7A7A7",
					}}
					disabled={disabled}
				>
					<option value="" disabled>
						Select specialisation
					</option>
					<option value="noSpecialisation">Select specialisation</option>
					{options?.map((spe, index) => (
						<option key={index} value={spe.name}>
							{spe.name}
						</option>
					))}
				</select>
			</div>
			<img
				src="./img/icon/dropdown-icon.png"
				alt=""
				className="dropdown-icon-style"
			/>
		</div>
	);
};

export default DropdownSpecialisationListing;
